import RequestService from './request';

interface workshopGenerateParams {
    collectionId: string;
}

export interface WorkshopItem {
    id: string;
    icon: string;
    name: string;
    size: number;
    subscriptions: number;
    description?: string;
    time_updated?: string;
}

class FastdlService {
    sync(): Promise<void> {
        return RequestService.post('/servers/:server/fastdl');
    }

    generateWorkshopLua(data: workshopGenerateParams): Promise<WorkshopItem[]> {
        return RequestService.post('/servers/:server/fastdl/workshop-lua', data);
    }
}

export default new FastdlService();
